import React from "react";
import { clamp } from "lodash";
import { object } from "prop-types";

import Organism1 from "../FourCollection12Stories/Organism1/index";
import ComponentContainer from "../../layouts/component-container";
import CustomSlider from "../../atoms/CustomSlider";

import { hasCollectionHeader, trim } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./fourCollection12Stories.m.css";

const FourCollection12Stories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const {
    hide_load_more_button: hideLoadMoreButton = true,
    number_of_collections_to_show: numberOfCollectionsToShow = 4,
    first_column_theme: firstColumnTheme,
    second_column_theme: secondColumnTheme,
    third_column_theme: thirdColumnTheme,
    fourth_column_theme: fourthColumnTheme,
    fifth_column_theme: fifthColumnTheme,
    sixth_column_theme: sixthColumnTheme,
    seventh_column_theme: seventhColumnTheme,
    eighth_column_theme: eightColumnTheme,
    parent_collection_theme: parentCollectionTheme,
  } = collection["associated-metadata"] || {};

  const parentTheme = trim(parentCollectionTheme, "default");

  const hasParent = hasCollectionHeader(collection);
  const showCollection = clamp(numberOfCollectionsToShow, 8);
  const { mobile } = useDevice();

  const collectionItems = collection.items.filter(({ type }) => type === "collection").slice(0, showCollection);

  const theme = {
    0: trim(firstColumnTheme, "default"),
    1: trim(secondColumnTheme, "default"),
    2: trim(thirdColumnTheme, "default"),
    3: trim(fourthColumnTheme, "default"),
    4: trim(fifthColumnTheme, "default"),
    5: trim(sixthColumnTheme, "default"),
    6: trim(seventhColumnTheme, "default"),
    7: trim(eightColumnTheme, "default"),
  };

  const columnStyle = {
    "--number-of-row": Math.round(showCollection > 4 ? showCollection / 2 : showCollection),
  };

  const isRow2 = (index) => {
    const length = collectionItems.length;
    if (length === 8 && index > 3) {
      return true;
    } else if (length < 8 && index > 2) {
      return true;
    }
    return false;
  };

  if (!collectionItems.length) return null;

  const children = collectionItems.map((item, index) => (
    <Organism1
      key={index}
      collection={item}
      hasParentCollection={hasParent}
      hideLoadMoreButton={hideLoadMoreButton}
      theme={parentTheme === "default" ? theme[index] : "default"}
      className={`column ${isRow2(index) ? "row-2" : ""}`}
    />
  ));

  return (
    <ComponentContainer
      className={parentTheme}
      styleName={`base ${hasParent ? (parentTheme !== "default" ? "other-themes" : "default") : ""}`}
      style={columnStyle}
      isBanner={hasParent}
      isDesktopBanner={hasParent}
      collection={collection}
      titleClass="parent-title"
      bannerClass="parent-banner"
    >
      {hasParent ? (
        <div styleName="parent-wrapper">
          {mobile ? (
            <CustomSlider
              isNavigation={false}
              slidesPerView={{ mobileSlides: 1.2, tabSlides: 1.2 }}
              spacing={{ mobileSpace: 16, tabSpace: 16 }}
            >
              {children}
            </CustomSlider>
          ) : (
            <div styleName="no-slide-wrapper">{children}</div>
          )}
        </div>
      ) : (
        <div styleName="no-parent-wrapper">{children}</div>
      )}
    </ComponentContainer>
  );
};

FourCollection12Stories.propTypes = {
  collection: object,
};

FourCollection12Stories.nestedCollectionLimit = [10, 10, 10, 10, 10, 10, 10, 10];

export default FourCollection12Stories;
